// ============================================================
// GLOBAL COURSE CONTENT — single source of truth for shared course copy
// ============================================================
// Text that must read identically on EVERY course page lives here, not on the
// individual course page. Editing a value in this module changes that text
// across all courses at once — that is the point.
//
// This mirrors the CTA architecture in `ctaConfig.js`: a single global source
// with one reader function per value, so the storage can later move without
// touching any consumer.

import { getGlobalValue } from './globalContentStore';
//
// GLOBAL CONTENT note: this text is now edited at runtime on the admin "Global
// Course Content" page and persisted in the Yii2 `global_course_content` table.
// The live value is served through `globalContentStore` (hydrated once from
// `pages/getglobalcontent`); `resolveWhatYouLearnHeading()` reads it there.
// The constant below remains the FALLBACK used until hydration lands or when
// the backend is unavailable, so every course page always renders. Editing a
// value on the admin page updates that text across all courses at once — with
// no change to any course page's saved JSON.

// ---- Global text values (fallback) -------------------------------------
// Fallback value for the shared "What You'll Learn" heading. NOT surfaced as an
// Inspector field, so a page author cannot override it per course. The runtime
// source of truth is `globalContentStore` (key `what_you_learn_heading`); this
// mirrors that field's registered fallback.
export const GLOBAL_COURSE_CONTENT = {
  whatYouLearnHeading: "What You'll Learn",
};

// The ONLY reader of the shared "What You'll Learn" heading. Reads the live
// global value (with a compile-time fallback), so every course page picks up an
// admin edit with no other changes.
export function resolveWhatYouLearnHeading() {
  return getGlobalValue('what_you_learn_heading');
}

// The ONLY reader of the shared Alumni / Success Stories heading. Same contract
// as above: the H2 above the alumni carousel is a single global value (backend
// `alumni_heading`), never a per-course prop, so one admin edit updates every
// course page and the heading is never stored in a course page's saved JSON.
export function resolveAlumniHeading() {
  return getGlobalValue('alumni_heading');
}
